import { useState } from "react";
import { PageHead } from "../../components/admin/ui";
import ProductsTab from "../../components/admin/store/ProductsTab";
import CategoriesTab from "../../components/admin/store/CategoriesTab";
import OrdersTab from "../../components/admin/store/OrdersTab";
import DiscountsTab from "../../components/admin/store/DiscountsTab";
import ShippingTab from "../../components/admin/store/ShippingTab";

const TABS = [
  { key: "products", label: "PRODUCTS", el: <ProductsTab /> },
  { key: "categories", label: "CATEGORIES", el: <CategoriesTab /> },
  { key: "orders", label: "ORDERS", el: <OrdersTab /> },
  { key: "discounts", label: "DISCOUNTS / PROMO CODES", el: <DiscountsTab /> },
  { key: "shipping", label: "SHIPPING", el: <ShippingTab /> },
];

export default function AdminStore() {
  const [tab, setTab] = useState("products");
  return (
    <div data-testid="admin-store">
      <PageHead title="Store" sub="Products, categories, orders, promotions and shipping. Placeholder products must be explicitly activated before real commerce." />
      <div className="flex flex-wrap gap-2 mb-8 border-b border-white/10 pb-4">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`store-tab-${t.key}`}
            className={`font-mono text-[10px] tracking-[0.2em] border px-5 py-2.5 transition-colors ${
              tab === t.key ? "border-gold text-gold bg-gold/10" : "border-white/15 text-white/45 hover:border-white/40"}`}>
            {t.label}
          </button>
        ))}
      </div>
      {TABS.find((t) => t.key === tab)?.el}
    </div>
  );
}
